export const ACCOUNT_KEY = '@inter-cdpro/account-data'

export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development'
export const IS_TEST = process.env.NODE_ENV === 'test'
export const USE_MOCK = process.env.REACT_APP_USE_MOCK !== 'false'

// TODO: conferirir se esse link vai estar no nativo ou mockado
export const LINK_PDF_TEST = 'https://static.bancointer.com.br/openbanking/termos'
